/**
 * Rotating Text Component
 * 
 * Animates rotating text messages in the preview
 * 
 * @package TopBuddy
 */

import { useEffect, useState } from '@wordpress/element';

const RotatingText = ({ messages, speed, transitionType }) => {
	const [currentIndex, setCurrentIndex] = useState(0);
	const [leavingIndex, setLeavingIndex] = useState(null);

	useEffect(() => {
		// Don't animate if there's only one message or no messages
		if (messages.length <= 1) {
			return;
		}

		const interval = setInterval(() => {
			// Set leaving state for current message
			setLeavingIndex(currentIndex);
			
			// Immediately update to next index (this adds is-active to next message)
			const nextIdx = currentIndex === messages.length - 1 ? 0 : currentIndex + 1;
			setCurrentIndex(nextIdx);
			
			// After transition completes, clear the leaving state
			setTimeout(() => {
				setLeavingIndex(null);
			}, 320); // Match the CSS transition duration
		}, speed);

		return () => clearInterval(interval);
	}, [currentIndex, messages.length, speed]);

	return (
		<div 
			className="topbuddy-notification-bar-rotating-text" 
			data-speed={speed} 
			data-transition-type={transitionType}
		>
			{messages.map((message, index) => {
				const isActive = index === currentIndex;
				const isLeaving = index === leavingIndex;
				
				let className = 'topbuddy-notification-bar-rotating-text__message';
				if (isActive) {
					className += ' is-active';
				}
				if (isLeaving) {
					className += ' is-leaving';
				}

				return (
					<span key={index} className={className}>
						{message}
					</span>
				);
			})}
		</div>
	);
};

export default RotatingText;
